// extracted by mini-css-extract-plugin
module.exports = {"left":"style_left__n_v89","right":"style_right__spX8a"};